<div class="eint" *ngIf="verified; else gateTpl">

  <!-- ================= DEV2 WORKBENCH ACTION BAR ================= -->
  <div class="ei-workbench">
    <div class="ei-wb-title ei-mono">Dev2 Editorial Workbench <span class="ei-pill info">Dev2 · read-only prod evidence · publish OFF</span>
      <a class="ei-wb-btn ei-mono" [routerLink]="['/admin/editorial-review']">→ Article review queue</a></div>
    <div class="ei-wb-row">
      <input class="ei-wb-input ei-mono" [(ngModel)]="regInput" name="regInput"
             placeholder="Registration (e.g. FU2)" (keyup.enter)="loadTyped()" />
      <button class="ei-wb-btn ei-mono" (click)="loadTyped()">Load</button>
      <span class="ei-wb-sep"></span>
      <button class="ei-wb-btn primary ei-mono" [disabled]="building || !registration" (click)="buildDossier()">
        {{ building ? 'Building…' : '1 · Build dossier' }}</button>
      <button class="ei-wb-btn ei-mono" [disabled]="discovering || !dossier" (click)="discoverMedia()">
        {{ discovering ? 'Discovering…' : '2 · Discover media' }}</button>
      <button class="ei-wb-btn ei-mono" [disabled]="loadingBrief || !dossier" (click)="loadStoryBrief()">
        {{ loadingBrief ? 'Loading…' : '3 · Story brief' }}</button>
      <button class="ei-wb-btn ei-mono" [disabled]="generatingArticle || !dossier" (click)="generateArticle()">
        {{ generatingArticle ? 'Generating…' : '4 · Generate article' }}</button>
    </div>
    <div class="ei-wb-status ei-mono" *ngIf="registration">
      Active: <b>{{ registration }}</b> ·
      <ng-container *ngIf="dossier; else noDoss">dossier loaded ({{ dataSource === 'api' ? 'live API' : 'mock' }})</ng-container>
      <ng-template #noDoss>no dossier yet — click <b>Build dossier</b></ng-template>
    </div>
  </div>

  <!-- ================= SUBJECT HEADER ================= -->
  <header class="ei-subject" *ngIf="dossier as d">
    <span class="ei-plate special-title">{{ d.formattedRegistration }}</span>
    <div class="ei-subject-meta">
      <div class="ei-eyebrow ei-mono">Editorial Intelligence</div>
      <h1 class="ei-display">{{ d.formattedRegistration }} — Registration Intelligence</h1>
      <div class="ei-sub ei-mono" *ngIf="d.subtitle">{{ d.subtitle }}</div>
    </div>
    <div class="ei-subject-tags">
      <span class="ei-pill" [ngClass]="statusClass(d.status)">● {{ d.status | titlecase }}</span>
      <span class="ei-pill muted" *ngIf="d.storyType">{{ d.storyType }}</span>
      <span class="ei-pill" [ngClass]="dataSource === 'api' ? 'ok' : 'warn'">
        Data: {{ dataSource === 'api' ? 'Live API' : 'Mock (fixture)' }}
      </span>
      <span class="ei-pill info">Dev2 · Publish flag OFF</span>
    </div>
  </header>

  <!-- registration switcher (mock has FU2 + JK1) -->
  <div class="ei-switch ei-mono" *ngIf="dossier">
    <span>Dossier:</span>
    <button *ngFor="let reg of availableRegistrations"
            class="ei-switch-btn"
            [class.on]="registration === reg"
            (click)="goToRegistration(reg)">{{ reg }}</button>
  </div>

  <!-- ================= TABBAR ================= -->
  <nav class="ei-tabbar" *ngIf="dossier">
    <button *ngFor="let t of tabs"
            class="ei-tab ei-mono"
            [class.on]="activeTab === t.key"
            (click)="selectTab(t.key)">{{ t.label }}</button>
  </nav>

  <!-- ================= STATES ================= -->
  <div class="ei-content" *ngIf="loading">
    <div class="ei-empty ei-mono">Loading intelligence…</div>
  </div>

  <div class="ei-content" *ngIf="!loading && notAvailable">
    <div class="ei-empty">
      <h2 class="ei-display">No dossier for {{ registration }}</h2>
      <p class="ei-mono">No editorial intelligence is available for this registration yet.
        Available dossiers: <b>{{ availableRegistrations.join(', ') }}</b>.</p>
    </div>
  </div>

  <!-- ================= TAB CONTENT ================= -->
  <div class="ei-content" *ngIf="!loading && dossier as d" [ngSwitch]="activeTab">

    <!-- ---------- 1. INTELLIGENCE SUMMARY (Editorial Decision) ---------- -->
    <section *ngSwitchCase="'summary'">
      <div class="ei-pagehead">
        <div>
          <h2 class="ei-display">Editorial Decision</h2>
          <div class="ei-note ei-mono">Can this be published? Why? What still needs doing? What happens next?</div>
        </div>
        <div class="ei-tagcol">
          <span class="ei-pill info">AI-generated</span>
          <span class="ei-pill warn">Provisional · verify before publish</span>
        </div>
      </div>

      <!-- DECISION PANEL (replaces the old AI hero) -->
      <div class="ei-ai ei-decision" *ngIf="d.decision as dec">
        <div class="ei-ai-label ei-mono">◆ Editorial Decision · {{ d.formattedRegistration }}
          <span class="ei-ai-conf">Confidence: {{ d.summary.confidenceLabel }}</span>
        </div>

        <div class="ei-decision-grid">
          <div class="ei-rec">
            <div class="ei-rec-label ei-mono">Publication recommendation</div>
            <div class="ei-rec-value ei-display" [ngClass]="recommendationClass(dec.recommendation)">
              {{ recommendationLabel(dec.recommendation) }}
            </div>
            <p class="ei-rec-rationale">{{ dec.rationale }}</p>
          </div>

          <div class="ei-score">
            <div class="ei-score-ring" [ngClass]="scoreBand(storyScore(dec))">
              <span class="ei-score-num ei-display">{{ storyScore(dec) }}</span>
              <span class="ei-score-of ei-mono">/ 100</span>
            </div>
            <div class="ei-score-label ei-mono">Story score</div>
          </div>
        </div>

        <!-- score breakdown -->
        <div class="ei-metrics">
          <div class="ei-metric" *ngFor="let m of dec.storyScore.metrics">
            <div class="ei-metric-top ei-mono">
              <span>{{ m.label }}</span><span [ngClass]="scoreBand(m.value)">{{ m.value }}</span>
            </div>
            <div class="ei-metric-bar"><i [ngClass]="scoreBand(m.value)" [style.width.%]="m.value"></i></div>
          </div>
        </div>

        <!-- blockers -->
        <div class="ei-blockers" *ngIf="dec.blockers?.length">
          <div class="ei-blockers-h ei-mono">Publication blockers</div>
          <div class="ei-blocker" *ngFor="let b of dec.blockers">
            <span class="ei-blocker-dot" [ngClass]="severityClass(b.severity)"></span>
            <span class="ei-blocker-text">{{ b.text }}</span>
            <span class="ei-pill" [ngClass]="severityClass(b.severity)">{{ b.severity }}</span>
          </div>
        </div>
      </div>

      <!-- WHY — supporting context (was the hero narrative) -->
      <div class="ei-sectiont ei-mono">Why</div>
      <div class="ei-card ei-why">
        <div class="ei-move" *ngIf="d.summary.movement as mv">
          <div class="ei-fig-block">
            <span class="ei-fig from ei-display">{{ mv.from.figure }}</span>
            <span class="ei-cap ei-mono">{{ mv.from.caption }}</span>
          </div>
          <span class="ei-arrow">→</span>
          <div class="ei-fig-block">
            <span class="ei-fig to ei-display">{{ mv.to.figure }}</span>
            <span class="ei-cap ei-mono">{{ mv.to.caption }}</span>
          </div>
          <div class="ei-delta">
            <span class="ei-delta-v ei-display">{{ mv.deltaValue }}</span>
            <span class="ei-delta-l ei-mono">{{ mv.deltaLabel }}</span>
          </div>
        </div>
        <p class="ei-why-narrative">{{ d.summary.narrative }}</p>
        <div class="ei-verdict-inline">
          <span class="ei-verdict-badge ei-mono">{{ d.summary.verdictBadge }}</span>
          <p>{{ d.summary.verdictText }}</p>
        </div>
      </div>

      <div class="ei-facets">
        <div class="ei-facet" *ngFor="let f of d.summary.keyFacets">
          <div class="ei-facet-h ei-mono">{{ f.heading }}</div>
          <p>{{ f.body }}</p>
        </div>
      </div>

      <!-- NEXT ACTIONS -->
      <div class="ei-sectiont ei-mono">Next Actions</div>
      <div class="ei-actions" *ngIf="d.nextActions?.length">
        <button *ngFor="let a of d.nextActions"
                class="ei-action"
                [class.disabled]="!a.enabled"
                (click)="runAction(a)">
          <span class="ei-action-label">{{ a.label }}</span>
          <span class="ei-action-state ei-mono" *ngIf="!a.enabled">Prototype</span>
          <span class="ei-action-state on ei-mono" *ngIf="a.enabled">Open ↗</span>
        </button>
      </div>
    </section>

    <!-- ---------- 2. READINESS ---------- -->
    <section *ngSwitchCase="'readiness'">
      <div class="ei-pagehead">
        <h2 class="ei-display">Editorial Readiness</h2>
        <div class="ei-note ei-mono">What is done, partial, or outstanding — before the percentages.</div>
      </div>

      <!-- primary: meaningful editorial facets -->
      <div class="ei-facets-readiness" *ngIf="d.readinessFacets?.length">
        <div class="ei-rfacet" *ngFor="let f of d.readinessFacets">
          <div class="ei-rfacet-top">
            <span class="ei-rfacet-label">{{ f.label }}</span>
            <span class="ei-pill" [ngClass]="stateClass(f.state)">{{ stateLabel(f.state) }}</span>
          </div>
          <div class="ei-rfacet-detail ei-mono" *ngIf="f.detail">{{ f.detail }}</div>
        </div>
      </div>

      <div class="ei-gate ei-mono" *ngIf="!d.internalDataAvailable">
        <b>No internal data</b>
        <span>This registration has no PlateX Tier-1 record — its factual spine is external-only. Internal readiness is 0% by design, not omission.</span>
      </div>

      <!-- secondary: the original category bars -->
      <div class="ei-sectiont ei-mono">Detailed coverage</div>
      <div class="ei-card ei-bars ei-bars-secondary">
        <div class="ei-overall">
          <span class="ei-overall-l ei-mono">Overall completeness</span>
          <span class="ei-overall-v ei-display" [ngClass]="band(overallReadiness())">{{ overallReadiness() }}%</span>
        </div>
        <div class="ei-bar-row" *ngFor="let c of d.readiness">
          <span class="ei-bar-l ei-mono">{{ c.key }}</span>
          <span class="ei-seg">
            <i *ngFor="let on of segments(c.value)" [class]="on ? band(c.value) : ''"></i>
          </span>
          <span class="ei-bar-pc ei-mono" [ngClass]="band(c.value)">{{ c.value }}%</span>
        </div>
      </div>
    </section>

    <!-- ---------- 3. TIMELINE ---------- -->
    <section *ngSwitchCase="'timeline'">
      <div class="ei-pagehead">
        <h2 class="ei-display">Timeline</h2>
        <div class="ei-note ei-mono">Expand an event for confidence, sources, linked evidence and notes.</div>
      </div>
      <div class="ei-card">
        <div class="ei-tevent2" *ngFor="let ev of d.timeline; let i = index" [class.open]="isExpanded(i)">
          <button class="ei-tevent-head" (click)="toggleEvent(i)">
            <span class="ei-tevent-yr ei-mono">{{ ev.date }}</span>
            <span class="ei-tevent-ev">{{ ev.event }}</span>
            <span class="ei-tevent-badges">
              <span class="ei-pill" [ngClass]="confClass(ev.confidence! >= 0.7 ? 'high' : ev.confidence! >= 0.4 ? 'low' : 'verylow')">conf {{ ev.confidence }}</span>
              <span class="ei-pill muted ei-mono" *ngIf="ev.sourceIds?.length">{{ ev.sourceIds!.length }} src</span>
              <span class="ei-tevent-caret ei-mono">{{ isExpanded(i) ? '▾' : '▸' }}</span>
            </span>
          </button>

          <div class="ei-tevent-detail" *ngIf="isExpanded(i)">
            <div class="ei-tevent-note ei-mono" *ngIf="ev.note">{{ ev.note }}</div>

            <div class="ei-tevent-block" *ngIf="ev.sourceIds?.length">
              <div class="ei-tevent-blockh ei-mono">Sources</div>
              <div class="ei-chips">
                <ng-container *ngFor="let id of ev.sourceIds">
                  <a class="ei-chip ei-mono" *ngIf="sourceById(id) as s" [href]="s.url" target="_blank" rel="noopener">[{{ id }}] {{ s.publisher }}</a>
                </ng-container>
              </div>
            </div>

            <div class="ei-tevent-block" *ngIf="linkedEvidence(ev).length">
              <div class="ei-tevent-blockh ei-mono">Linked evidence</div>
              <div class="ei-tevent-link" *ngFor="let c of linkedEvidence(ev)">
                <span class="ei-pill" [ngClass]="usageClass(c.usagePolicy)">{{ tierLabel(c.tier) }}</span>
                <span class="ei-tevent-linktext">{{ c.text }}</span>
              </div>
            </div>

            <div class="ei-tevent-block">
              <div class="ei-tevent-blockh ei-mono">Editor note</div>
              <div class="ei-editornote" *ngIf="ev.editorNote">{{ ev.editorNote }}</div>
              <button class="ei-obtn ei-mono" *ngIf="!ev.editorNote" (click)="toast('Editor notes — prototype (not wired yet).')">+ Add editor note</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ---------- 4. EVIDENCE ---------- -->
    <section *ngSwitchCase="'evidence'">
      <div class="ei-pagehead">
        <h2 class="ei-display">Evidence</h2>
        <div class="ei-note ei-mono">Each claim, its tier, what it may be used for, and the sources behind it.</div>
      </div>
      <div class="ei-card ei-claim" *ngFor="let c of d.claims">
        <div class="ei-claim-top">
          <span class="ei-pill" [ngClass]="tierClass(c.tier)">{{ tierLabel(c.tier) }}</span>
          <span class="ei-pill" [ngClass]="usageClass(c.usagePolicy)">{{ usageLabel(c.usagePolicy) }}</span>
          <span class="ei-pill muted ei-mono">conf {{ c.confidence }}</span>
        </div>
        <p class="ei-claim-text">{{ c.text }}</p>
        <div class="ei-purposes" *ngIf="c.supports?.length">
          <span class="ei-purpose ei-mono" *ngFor="let p of c.supports">{{ purposeLabel(p) }}</span>
        </div>
        <div class="ei-claim-note ei-mono" *ngIf="c.uncertaintyNote">⚠ {{ c.uncertaintyNote }}</div>
        <div class="ei-chips">
          <ng-container *ngFor="let id of c.sourceIds">
            <a class="ei-chip ei-mono" *ngIf="sourceById(id) as s" [href]="s.url" target="_blank" rel="noopener">
              [{{ id }}] {{ s.publisher }}
            </a>
          </ng-container>
        </div>
      </div>
    </section>

    <!-- ---------- 5. SOURCES ---------- -->
    <section *ngSwitchCase="'sources'">
      <div class="ei-pagehead">
        <h2 class="ei-display">Sources</h2>
        <div class="ei-note ei-mono">{{ d.sources.length }} sources · {{ piiSourceCount() }} flagged PII (internal only)</div>
      </div>
      <div class="ei-card ei-source" *ngFor="let s of d.sources">
        <div class="ei-source-top">
          <span class="ei-pill" [ngClass]="tierClass(s.tier)">{{ tierLabel(s.tier) }}</span>
          <span class="ei-source-pub">{{ s.publisher }}</span>
          <span class="ei-pill" [ngClass]="confClass(s.sourceConfidence.label)">{{ s.sourceConfidence.label }} · {{ s.sourceConfidence.score }}</span>
          <span class="ei-pill" [ngClass]="usageClass(s.usagePolicy)">{{ usageLabel(s.usagePolicy) }}</span>
          <span class="ei-pill bad ei-mono" *ngIf="s.piiPresent">PII</span>
        </div>
        <a class="ei-source-title" [href]="s.url" target="_blank" rel="noopener">{{ s.title }} ↗</a>

        <!-- enrichment grid (placeholders where data is unavailable) -->
        <div class="ei-source-grid">
          <div class="ei-sg"><span class="ei-sg-k ei-mono">Publisher</span><span class="ei-sg-v">{{ s.publisher || '—' }}</span></div>
          <div class="ei-sg"><span class="ei-sg-k ei-mono">Tier</span><span class="ei-sg-v">{{ tierLabel(s.tier) }}</span></div>
          <div class="ei-sg"><span class="ei-sg-k ei-mono">Confidence</span><span class="ei-sg-v">{{ s.sourceConfidence.label }} · {{ s.sourceConfidence.score }}</span></div>
          <div class="ei-sg"><span class="ei-sg-k ei-mono">Discovery</span><span class="ei-sg-v">{{ discoveryFor(s) }}</span></div>
          <div class="ei-sg"><span class="ei-sg-k ei-mono">Last verified</span><span class="ei-sg-v">{{ lastVerifiedFor(s) }}</span></div>
          <div class="ei-sg"><span class="ei-sg-k ei-mono">Licence</span><span class="ei-sg-v">{{ licenceFor(s) }}</span></div>
          <div class="ei-sg"><span class="ei-sg-k ei-mono">Archived</span><span class="ei-sg-v">{{ archivedLabel(s) }}</span></div>
        </div>

        <div class="ei-source-actions">
          <a class="ei-obtn ei-mono" [href]="s.url" target="_blank" rel="noopener">Open Original ↗</a>
          <a class="ei-obtn ei-mono" *ngIf="s.archived && s.archiveUrl" [href]="s.archiveUrl" target="_blank" rel="noopener">Open Archive ↗</a>
          <button class="ei-obtn ei-mono disabled" *ngIf="!(s.archived && s.archiveUrl)" (click)="toast('Archive snapshot — prototype (not wired yet).')">Open Archive</button>
        </div>

        <p class="ei-source-extract" *ngIf="s.extractedText">{{ s.extractedText }}</p>
      </div>
    </section>

    <!-- ---------- 6. MEDIA & RIGHTS ---------- -->
    <section *ngSwitchCase="'media'">
      <div class="ei-pagehead">
        <h2 class="ei-display">Media &amp; Rights</h2>
        <div class="ei-pagehead-actions">
          <div class="ei-note ei-mono">{{ discoveredMediaCount() }} publish-ready · {{ referenceRequiredCount() }} reference/rights-required · {{ generatedMediaCount() }} generated · {{ retiredRejectedCount() }} retired/rejected · {{ displayableMediaCount() }} displayable now</div>
          <button class="ei-obtn ei-mono" [disabled]="discovering" (click)="discoverMedia()">
            {{ discovering ? 'Discovering…' : 'Discover media' }}
          </button>
        </div>
      </div>
      <div style="margin:0 0 18px;">
        <pla-editorial-import-panel [registration]="registration" (imported)="onReferencesImported()"></pla-editorial-import-panel>
      </div>
      <div class="ei-gate ei-mono">
        <b>Rights gate</b>
        <span>Nothing is displayed publicly unless <b>rights permit</b> AND an editor approves it. Third-party media is referenced, never downloaded or rehosted.</span>
      </div>

      <!-- Honest summary of the last discovery run -->
      <div class="ei-gate ei-mono" *ngIf="discoveryResult?.status === 'completed'"
           [ngClass]="discoveryResult?.noRealMedia ? 'warn' : 'ok'">
        <b>{{ discoveryResult?.noRealMedia ? 'No publish-ready media found' : 'Discovery result' }}</b>
        <span>{{ discoveryResult?.message }}</span>
        <span *ngIf="discoveryResult?.referenceAssets">
          {{ discoveryResult?.referenceAssets }} reference asset(s) recorded with rights flags for review (not publish-ready).
        </span>
        <span *ngIf="discoveryResult?.notConfiguredProviders?.length">
          Not configured (no API key): {{ discoveryResult?.notConfiguredProviders?.join(', ') }}.
        </span>
        <span *ngIf="discoveryResult?.retiredStale">
          Retired {{ discoveryResult?.retiredStale }} stale item(s) no longer returned by discovery.
        </span>
      </div>

      <div class="ei-empty ei-mono" *ngIf="!d.media.length">
        No media discovered yet. Click <b>Discover media</b> to search by registration and entities (YouTube Data API video search when keyed, plus the keyless licence-first sources Openverse, Wikipedia and Wikimedia Commons) AND to record every URL the dossier already cites — auction, dealer, social, stock and archive pages — each rights-classified as a reference. Publish-ready assets, reference/rights-required assets, and generated chart/map placeholders are listed separately.
      </div>

      <!-- 1) Discovered media that is publish-ready (clearable rights) -->
      <div class="ei-media-group" *ngIf="publishReadyMedia().length">
        <h3 class="ei-subhead ei-display">Discovered media — publish-ready <span class="ei-pill ok ei-mono">{{ publishReadyMedia().length }}</span></h3>
        <p class="ei-note ei-mono">Live provider hits whose rights we can clear (PlateX-owned, public-domain/CC, or embed-only). Referenced only — never downloaded or rehosted; nothing is public until an editor approves.</p>
        <div class="ei-media-grid">
          <ng-container *ngFor="let m of publishReadyMedia()">
            <ng-container *ngTemplateOutlet="mediaCard; context: { $implicit: m }"></ng-container>
          </ng-container>
        </div>
      </div>

      <!-- 2) Reference / rights-required — recorded, NOT publish-ready -->
      <div class="ei-media-group ei-media-group-reference" *ngIf="referenceRequiredMedia().length">
        <h3 class="ei-subhead ei-display">Reference / rights required <span class="ei-pill warn ei-mono">{{ referenceRequiredMedia().length }}</span></h3>
        <p class="ei-note ei-mono">Relevant assets we found or the dossier cites (auction, dealer, social, stock, archive, known sources) whose rights are <b>not</b> clear — licence required, permission required, reference-only, or unknown. Recorded and rights-flagged for review; <b>never</b> presented as publish-ready. Nothing is downloaded or rehosted.</p>
        <div class="ei-media-grid">
          <ng-container *ngFor="let m of referenceRequiredMedia()">
            <ng-container *ngTemplateOutlet="mediaCard; context: { $implicit: m }"></ng-container>
          </ng-container>
        </div>
      </div>

      <!-- 3) Generated requirements (charts/maps) — NOT discovered media -->
      <div class="ei-media-group" *ngIf="generatedRequirements().length">
        <h3 class="ei-subhead ei-display">Generated requirements <span class="ei-pill muted ei-mono">{{ generatedRequirements().length }}</span></h3>
        <p class="ei-note ei-mono">PlateX-generated chart/map placeholders derived from the dossier data — NOT discovered third-party media, and no external rights attach.</p>
        <div class="ei-media-grid">
          <ng-container *ngFor="let m of generatedRequirements()">
            <ng-container *ngTemplateOutlet="mediaCard; context: { $implicit: m }"></ng-container>
          </ng-container>
        </div>
      </div>

      <!-- 4) Fixture / reference-only media -->
      <div class="ei-media-group" *ngIf="fixtureReferenceMedia().length">
        <h3 class="ei-subhead ei-display">Fixture / reference media <span class="ei-pill info ei-mono">{{ fixtureReferenceMedia().length }}</span></h3>
        <p class="ei-note ei-mono">Uploaded, dealer-supplied or historic-archive reference material provided outside automated discovery.</p>
        <div class="ei-media-grid">
          <ng-container *ngFor="let m of fixtureReferenceMedia()">
            <ng-container *ngTemplateOutlet="mediaCard; context: { $implicit: m }"></ng-container>
          </ng-container>
        </div>
      </div>

      <!-- 5) Retired (system) / rejected (editor) — kept for audit, hidden from active set -->
      <div class="ei-media-group ei-media-group-muted" *ngIf="retiredRejectedMedia().length">
        <h3 class="ei-subhead ei-display">Retired &amp; rejected <span class="ei-pill muted ei-mono">{{ retiredRejectedMedia().length }}</span></h3>
        <p class="ei-note ei-mono"><b>Retired</b> = a later discovery run no longer returned this item (e.g. a weak public-domain keyword match), set automatically. <b>Rejected</b> = an editor decision. Both are kept for audit and never shown publicly.</p>
        <div class="ei-media-grid">
          <ng-container *ngFor="let m of retiredRejectedMedia()">
            <ng-container *ngTemplateOutlet="mediaCard; context: { $implicit: m }"></ng-container>
          </ng-container>
        </div>
      </div>

      <!-- Shared media card (rendered by each group above) -->
      <ng-template #mediaCard let-m>
        <div class="ei-card ei-media">
          <div class="ei-media-top">
            <span class="ei-pill muted ei-mono">{{ m.mediaType }}<span *ngIf="m.platform"> · {{ m.platform }}</span></span>
            <span class="ei-pill" [ngClass]="licenceClass(m.licenceStatus)">{{ licenceLabel(m.licenceStatus) }}</span>
            <span class="ei-pill muted ei-mono" *ngIf="m.sourceType === 'generated'">generated</span>
            <span class="ei-pill ei-mono" [ngClass]="mediaStatusClass(m.status)" *ngIf="m.status">{{ mediaStatusLabel(m.status) }}</span>
          </div>

          <!-- Thumbnail (remote reference only — never downloaded or rehosted).
               Falls back to a placeholder when there is no remote thumbnail or the
               remote image fails to load (bot-walled / hotlink-blocked). -->
          <div class="ei-media-thumb" *ngIf="thumbFor(m) && !thumbBroken(m); else noThumb">
            <img [src]="thumbFor(m)" [alt]="m.caption || m.what || 'reference thumbnail'"
                 loading="lazy" referrerpolicy="no-referrer" (error)="onThumbError(m)" />
          </div>
          <ng-template #noThumb>
            <div class="ei-media-thumb ei-media-thumb-empty ei-mono">No thumbnail available</div>
          </ng-template>
          <div class="ei-media-links ei-mono">
            <a *ngIf="m.url || m.embedUrl" [href]="m.url || m.embedUrl" target="_blank" rel="noopener">Open source ↗</a>
            <a *ngIf="thumbFor(m)" [href]="thumbFor(m)" target="_blank" rel="noopener">Open image ↗</a>
          </div>

          <div class="ei-media-what">{{ m.what || m.caption }}</div>
          <div class="ei-media-meta ei-mono">
            <span *ngIf="m.provider">via {{ m.provider }}</span>
            <span *ngIf="relevancePct(m) !== null">· relevance {{ relevancePct(m) }}%</span>
            <span *ngIf="m.creator">· © {{ m.creator }}</span>
          </div>
          <div class="ei-media-relwhy ei-mono" *ngIf="m.relevanceReason">{{ m.relevanceReason }}</div>
          <div class="ei-media-verif ei-mono">
            <span [class.ok]="m.verifiedContent">{{ m.verifiedContent ? '✓' : '✕' }} content</span>
            <span [class.ok]="m.verifiedPlatform">{{ m.verifiedPlatform ? '✓' : '✕' }} platform</span>
            <span [class.ok]="m.verifiedOwner">{{ m.verifiedOwner ? '✓' : '✕' }} owner</span>
            <span [class.ok]="m.displayAllowed">{{ m.displayAllowed ? '✓' : '✕' }} display</span>
            <span [class.ok]="m.embedAllowed">{{ m.embedAllowed ? '✓' : '✕' }} embed</span>
          </div>
          <div class="ei-media-rights ei-mono" *ngIf="m.rightsNotes">{{ m.rightsNotes }}</div>
          <div class="ei-media-action ei-mono" *ngIf="m.editorActionRequired">
            <b>Editor action:</b> {{ m.editorActionRequired }}
          </div>
          <div class="ei-media-notes ei-mono" *ngIf="m.editorNotes && !isNoteOpen(m)">
            <b>Note:</b> {{ m.editorNotes }}
          </div>
          <div class="ei-chips" *ngIf="m.supportsClaimIds?.length">
            <span class="ei-pill info ei-mono">supports claim {{ m.supportsClaimIds!.join(', ') }}</span>
          </div>

          <!-- Inline note editor -->
          <div class="ei-note-editor" *ngIf="isNoteOpen(m)">
            <textarea class="ei-mono" [(ngModel)]="noteDraft" rows="2"
                      placeholder="Editor note for this asset…"></textarea>
            <div class="ei-note-editor-actions">
              <button class="ei-obtn ei-mono" [disabled]="isMediaPending(m)" (click)="saveNote(m)">Save note</button>
              <button class="ei-obtn ei-mono" (click)="cancelNote()">Cancel</button>
            </div>
          </div>

          <!-- Editor review controls -->
          <div class="ei-media-controls ei-mono" *ngIf="m.id != null">
            <button class="ei-obtn ok" [disabled]="isMediaPending(m)" (click)="approveMedia(m)">Approve</button>
            <button class="ei-obtn bad" [disabled]="isMediaPending(m)" (click)="rejectMedia(m)">Reject</button>
            <button class="ei-obtn warn" [disabled]="isMediaPending(m)" (click)="flagMedia(m)">Flag</button>
            <button class="ei-obtn" [disabled]="isMediaPending(m)" (click)="startNote(m)">Add note</button>
          </div>

          <a class="ei-media-link ei-mono" *ngIf="m.url || m.embedUrl"
             [href]="m.url || m.embedUrl" target="_blank" rel="noopener">Open source ↗</a>
        </div>
      </ng-template>
    </section>

    <!-- ---------- 7. COMPARABLES ---------- -->
    <section *ngSwitchCase="'comparables'">
      <div class="ei-pagehead"><h2 class="ei-display">Comparables</h2></div>
      <div class="ei-card">
        <div class="ei-comp" *ngFor="let cp of d.comparables">
          <span class="ei-plate sm special-title">{{ cp.registration }}</span>
          <div class="ei-comp-body">
            <div class="ei-comp-rel">{{ cp.relationship }}</div>
            <div class="ei-comp-note ei-mono" *ngIf="cp.note">{{ cp.note }}</div>
          </div>
          <div class="ei-comp-result ei-mono">
            <span *ngIf="cp.lastKnownResult; else noResult">{{ cp.lastKnownResult }}</span>
            <ng-template #noResult><span class="muted">no verified result</span></ng-template>
            <span class="ei-pill muted" *ngIf="!cp.internalDataFound">external</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ---------- 8. MARKET ANALYSIS ---------- -->
    <section *ngSwitchCase="'market'">
      <div class="ei-pagehead">
        <h2 class="ei-display">Market Analysis</h2>
        <div class="ei-note ei-mono" *ngIf="d.marketAnalysis.confidence">confidence {{ d.marketAnalysis.confidence }}</div>
      </div>
      <div class="ei-facets two">
        <div class="ei-facet" *ngIf="d.marketAnalysis.estimateVsResult">
          <div class="ei-facet-h ei-mono">Estimate vs result</div><p>{{ d.marketAnalysis.estimateVsResult }}</p>
        </div>
        <div class="ei-facet" *ngIf="d.marketAnalysis.priceGrowth">
          <div class="ei-facet-h ei-mono">Price growth</div><p>{{ d.marketAnalysis.priceGrowth }}</p>
        </div>
        <div class="ei-facet" *ngIf="d.marketAnalysis.marketConditions">
          <div class="ei-facet-h ei-mono">Market conditions</div><p>{{ d.marketAnalysis.marketConditions }}</p>
        </div>
        <div class="ei-facet" *ngIf="d.marketAnalysis.interpretation">
          <div class="ei-facet-h ei-mono">Interpretation</div><p>{{ d.marketAnalysis.interpretation }}</p>
        </div>
      </div>
      <div class="ei-indexslot ei-mono">
        <b>PlateX Index</b> — not connected in this dataset. The page shows no figure it cannot stand behind.
      </div>
    </section>

    <!-- ---------- 9. OUTSTANDING TASKS (was Research Gaps) ---------- -->
    <section *ngSwitchCase="'gaps'">
      <div class="ei-pagehead">
        <h2 class="ei-display">Outstanding Tasks</h2>
        <div class="ei-note ei-mono">{{ openTaskCount() }} open · each gap is now an actionable task</div>
      </div>

      <div class="ei-card ei-task" *ngFor="let t of d.outstandingTasks" [class.done]="t.completed">
        <div class="ei-task-check" (click)="toggleTask(t)">{{ t.completed ? '☑' : '☐' }}</div>
        <div class="ei-task-body">
          <div class="ei-task-top">
            <span class="ei-task-area">{{ t.area }}</span>
            <span class="ei-pill" [ngClass]="priorityClass(t.priority)">{{ t.priority }} priority</span>
            <span class="ei-pill muted ei-mono">{{ t.effort }}</span>
            <span class="ei-pill" [ngClass]="t.mode === 'ai' ? 'info' : 'muted'">{{ t.mode === 'ai' ? 'AI' : 'Manual' }}</span>
            <span class="ei-pill ok" *ngIf="t.completed">Completed</span>
          </div>
          <div class="ei-task-detail">{{ t.detail }}</div>
          <div class="ei-task-actions">
            <button class="ei-obtn ei-mono" *ngIf="t.mode === 'ai'" (click)="toast(t.area + ' — queued to AI (prototype).')">Queue AI</button>
            <button class="ei-obtn ei-mono" *ngIf="t.mode === 'manual'" (click)="toast(t.area + ' — started (prototype).')">Start</button>
            <button class="ei-obtn ei-mono" (click)="toggleTask(t)">{{ t.completed ? 'Reopen' : 'Mark done' }}</button>
          </div>
        </div>
      </div>

      <!-- fallback if a dossier has no V2 tasks: the original gaps list -->
      <ng-container *ngIf="!d.outstandingTasks?.length">
        <div class="ei-card ei-gap" *ngFor="let g of d.researchGaps">
          <span class="ei-pill" [ngClass]="severityClass(g.severity)">{{ g.severity }}</span>
          <div class="ei-gap-body">
            <div class="ei-gap-area">{{ g.area }}</div>
            <div class="ei-gap-detail">{{ g.detail }}</div>
          </div>
        </div>
      </ng-container>
    </section>

    <!-- ---------- 10. STORY PREVIEW ---------- -->
    <section *ngSwitchCase="'story'">
      <div class="ei-pagehead">
        <h2 class="ei-display">Story Preview</h2>
        <span class="ei-pill warn">Draft · not published · flag OFF</span>
      </div>
      <article class="ei-story">
        <div class="ei-story-kick ei-mono">{{ d.story.kicker }}</div>
        <div class="ei-story-cover ei-display">{{ d.story.coverline }}</div>
        <h1 class="ei-story-title ei-display">{{ d.story.title }}</h1>
        <p class="ei-story-stand ei-display">{{ d.story.standfirst }}</p>
        <div class="ei-story-figure">
          <span class="ei-story-fig ei-display">{{ d.story.figure }}</span>
          <span class="ei-story-figlbl ei-mono">{{ d.story.figureLabel }}</span>
        </div>
        <div class="ei-story-sec" *ngFor="let s of d.story.sections">
          <div class="ei-story-mark ei-mono">{{ s.mark }}</div>
          <p>{{ s.body }}</p>
        </div>
        <div class="ei-story-refs">
          <div class="ei-story-mark ei-mono">References</div>
          <ol><li class="ei-mono" *ngFor="let r of d.story.references">{{ r }}</li></ol>
        </div>
      </article>
    </section>

    <!-- ---------- STORY BRIEF (M2) ---------- -->
    <section *ngSwitchCase="'brief'">
      <div class="ei-pagehead">
        <h2 class="ei-display">Story Detection &amp; Editorial Brief</h2>
        <span class="ei-pill info">M2 · GET /story-brief</span>
      </div>

      <div class="ei-empty ei-mono" *ngIf="!storyBrief && !loadingBrief">
        Click <b>“3 · Story brief”</b> above to run story detection for {{ registration }}.
      </div>
      <div class="ei-empty ei-mono" *ngIf="loadingBrief">Loading story brief…</div>

      <ng-container *ngIf="storyBrief as sb">
        <!-- NOT READY -->
        <div class="ei-callout bad" *ngIf="sb.verdict === 'NOT_READY_FOR_ARTICLE'">
          <div class="ei-callout-h ei-mono">⚠ NOT READY FOR ARTICLE</div>
          <ul><li *ngFor="let r of sb.notReadyReasons">{{ r }}</li></ul>
        </div>

        <!-- STORY DETECTION -->
        <div class="ei-card" *ngIf="sb.storyDetection as sdx">
          <div class="ei-wb-kv ei-mono">
            <span>Story exists: <b>{{ sdx.storyExists }}</b></span>
            <span>Primary: <b>{{ sdx.storyType || '—' }}</b></span>
            <span>Score: <b>{{ sdx.storyScore }}/100</b></span>
            <span>Confidence: <b>{{ sdx.confidence }}</b></span>
          </div>
          <p *ngIf="sdx.primaryNarrative"><b>Primary narrative:</b> {{ sdx.primaryNarrative.narrative }}</p>
          <div class="ei-chips">
            <span class="ei-chip ei-mono" *ngFor="let s of rankedTop(sb)">{{ s.label }} · {{ s.score }}</span>
          </div>
          <p class="ei-note ei-mono" *ngIf="sdx.recommendedEditorialDirection">
            Direction: {{ sdx.recommendedEditorialDirection }}</p>
        </div>

        <!-- EDITORIAL BRIEF -->
        <div class="ei-card" *ngIf="sb.editorialBrief as br">
          <h3 class="ei-display">Editorial Brief</h3>
          <p><b>Headline options</b></p>
          <ul><li *ngFor="let h of br.headlineOptions">{{ h.text }}</li></ul>
          <p><b>Standfirst:</b> {{ br.standfirst?.text }}</p>
          <p><b>Key angle:</b> {{ br.keyAngle?.text }}</p>
          <p class="ei-mono"><b>Audience:</b> {{ br.targetAudience }} · <b>Tone:</b> {{ br.tone }}
             · <b>Words:</b> {{ br.wordCountRecommendation }} · <b>Read:</b> {{ br.readingTimeMinutes }} min</p>
          <p><b>Verified facts</b></p>
          <ul><li *ngFor="let v of br.verifiedFacts">{{ v.text }}</li></ul>
          <p *ngIf="br.evidenceRequiringCaution?.length"><b>Evidence requiring caution</b></p>
          <ul><li *ngFor="let c of br.evidenceRequiringCaution">{{ c.note }}</li></ul>
          <p *ngIf="br.missingEvidence?.length"><b>Missing evidence</b></p>
          <ul><li *ngFor="let m of br.missingEvidence">{{ m }}</li></ul>
          <p class="ei-mono"><b>SEO:</b> {{ br.seoTitle }} · <b>slug:</b> {{ br.suggestedUrlSlug }}</p>
        </div>
      </ng-container>
    </section>

    <!-- ---------- GENERATED ARTICLE (M3) ---------- -->
    <section *ngSwitchCase="'article'">
      <div class="ei-pagehead">
        <h2 class="ei-display">Generated Article</h2>
        <span class="ei-pill info">M3 · POST /generate-article · persisted</span>
      </div>

      <div class="ei-empty ei-mono" *ngIf="!article && !generatingArticle">
        Click <b>“4 · Generate article”</b> above to produce the article for {{ registration }}.
      </div>
      <div class="ei-empty ei-mono" *ngIf="generatingArticle">Generating article…</div>

      <ng-container *ngIf="article as a">
        <div class="ei-callout bad" *ngIf="a.status === 'not_ready'">
          <div class="ei-callout-h ei-mono">⚠ NOT READY FOR ARTICLE</div>
          <ul><li *ngFor="let r of a.reasons">{{ r }}</li></ul>
        </div>
        <div class="ei-callout bad" *ngIf="a.status === 'error'">
          <div class="ei-callout-h ei-mono">Generation error</div>
          <p class="ei-mono">{{ a.detail }}</p>
        </div>

        <ng-container *ngIf="a.status === 'generated' && a.article as art">
          <div class="ei-card">
            <div class="ei-wb-kv ei-mono">
              <span><b>SEO title:</b> {{ art.seoTitle }}</span>
              <span><b>Slug:</b> {{ art.urlSlug }}</span>
            </div>
            <p class="ei-mono"><b>Meta description:</b> {{ art.metaDescription }}</p>
            <p class="ei-mono"><b>Primary keyword:</b> {{ art.primaryKeyword }}</p>
            <p class="ei-note ei-mono">{{ art.confidenceStatement }}</p>
          </div>

          <div class="ei-card">
            <h3 class="ei-display">Article (markdown)</h3>
            <pre class="ei-markdown">{{ art.markdown }}</pre>
          </div>

          <div class="ei-card" *ngIf="art.sourceReferences?.length">
            <h3 class="ei-display">References</h3>
            <ol><li class="ei-mono" *ngFor="let r of art.sourceReferences">{{ r }}</li></ol>
          </div>

          <div class="ei-card" *ngIf="art.imagePlacements?.length || art.videoPlacements?.length">
            <h3 class="ei-display">Media references</h3>
            <ul class="ei-mono">
              <li *ngFor="let i of art.imagePlacements">image · {{ i.placement }} · {{ i.rightsCategory }} · {{ i.url }}</li>
              <li *ngFor="let v of art.videoPlacements">video · {{ v.placement }} · {{ v.rightsCategory }} · {{ v.url }}</li>
            </ul>
          </div>

          <div class="ei-card" *ngIf="art.editorialNotes?.length">
            <h3 class="ei-display">Editorial notes</h3>
            <ul><li *ngFor="let n of art.editorialNotes">{{ n }}</li></ul>
          </div>
        </ng-container>
      </ng-container>
    </section>

    <!-- ---------- 11. CREATIVE STUDIO ---------- -->
    <section *ngSwitchCase="'studio'">
      <div class="ei-pagehead">
        <div>
          <h2 class="ei-display">Publication / Creative Studio</h2>
          <div class="ei-note ei-mono">Owned editorial imagery — supporting infrastructure, not the research product</div>
        </div>
        <span class="ei-pill info">Workflow prototype · no generation yet</span>
      </div>

      <div class="ei-gate ei-mono">
        <b>Gated</b>
        <span>Story is <b>{{ d.status | titlecase }}</b>. You can compose and queue concepts now; export &amp; publication unlock on approval and once rights are clear. Publish flag remains OFF.</span>
      </div>

      <!-- provenance legend -->
      <div class="ei-legend">
        <div class="ei-leg authentic"><div class="ei-leg-t ei-display">Authentic media</div>
          <p>Documentary evidence — press, auction, historic. Preferred where rights are cleared. Sourced in Media Library, never created here.</p></div>
        <div class="ei-leg owned"><div class="ei-leg-t ei-display">PlateX render</div>
          <p>Plate Viewer output — an owned PlateX editorial asset, safe to display and licence. This studio produces these.</p></div>
        <div class="ei-leg concept"><div class="ei-leg-t ei-display">AI-assisted concept</div>
          <p>Exploration only. Never documentary evidence, never a real photograph. Always watermarked as a concept.</p></div>
      </div>

      <!-- plate viewer deep-link -->
      <a class="ei-openpv" [routerLink]="plateViewerLink">↗ Open Plate Viewer · {{ d.formattedRegistration }} preloaded</a>
      <div class="ei-pvnote ei-mono">Deep-links the Plate Viewer with the registration set</div>

      <!-- asset slots -->
      <div class="ei-sectiont ei-mono">Asset slots · one source render, all sizes</div>
      <div class="ei-outs">
        <div class="ei-out" *ngFor="let slot of d.creativeSlots">
          <div class="ei-out-pv" [style.aspect-ratio]="slot.aspect">{{ d.formattedRegistration }}</div>
          <div class="ei-out-meta">
            <span class="ei-out-n ei-display">{{ slot.name }}</span>
            <span class="ei-out-dim ei-mono">{{ slot.dimensions }}</span>
          </div>
          <span class="ei-pill" [ngClass]="provenanceClass(slot.provenance)">{{ provenanceLabel(slot.provenance) }}</span>
          <button class="ei-obtn ei-mono" (click)="toast(slot.name + ' export queued — unlocks on approval (prototype).')">Queue export</button>
        </div>
      </div>

      <!-- discipline -->
      <div class="ei-reco">
        <div class="ei-card rec">
          <div class="ei-facet-h ei-mono">Recommended hero</div>
          <p><b>PlateX render</b> — {{ d.formattedRegistration }} has <b>{{ displayableMediaCount() }} cleared authentic images</b>, so an owned Plate Viewer render is the route to a premium hero.</p>
          <p class="ei-muted">If authentic media is later licensed, it takes precedence — house rule: authentic over render where rights are clear.</p>
        </div>
        <div class="ei-card">
          <div class="ei-facet-h ei-mono">Source discipline</div>
          <ul>
            <li>Documentary evidence is never created here — it lives in Media Library.</li>
            <li>Renders are owned PlateX assets; concepts are watermarked and never used as evidence.</li>
            <li>Third-party media is embedded or linked, never downloaded or rehosted.</li>
            <li>Export is gated on story approval and clear rights.</li>
          </ul>
        </div>
      </div>
    </section>

  </div>

  <!-- toast -->
  <div class="ei-toast" [class.show]="toastMessage">{{ toastMessage }}</div>
</div>

<ng-template #gateTpl>
  <div class="eint"><div class="ei-content"><div class="ei-empty ei-mono">Checking admin access…</div></div></div>
</ng-template>
